import { Permissions } from './masterdata';

function createDrawerItem({
  text,
  route,
  show = true,
  openInNewTab = false,
  openInSameTab = false,
  items = null,
  addt = {},
}) {
  return show
    ? {
        text,
        icon: null,
        meta: openInNewTab || openInSameTab ? 'open_in_new' : null,
        anchor: {
          route,
          target: openInNewTab ? 'blank' : openInSameTab ? 'same' : 'self',
        },
        items,
        ...addt,
      }
    : null;
}

// This is the data to create drawer items for when you're on the
// partner tab. Most transforms will be done in the drawer transformer.
// The only filtering that will be done HERE is if we want to `show` a
// drawer item or not. This allows an explicit disable of a drawer item.
export default {
  admin: [
    {
      text: 'Admin',
      items: [
        createDrawerItem({
          text: 'Integrations',
          route: 'partner-integration',
          addt: {
            roles: ['SuperAdmin'],
          },
        }),
        createDrawerItem({
          text: 'API Access',
          route: 'credmgmt',
          addt: {
            roles: ['SuperAdmin'],
            permissions: [Permissions.canAccessCredentialsManagement],
          },
        }),
      ].filter(Boolean),
    },
  ],
};
